var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98.664,
    height: 94.045,
    viewBox: "0 0 98.664 94.045",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 98.664,
    height: 94.045
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(128)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M36.351,7.541s-1.483-1.116-2.593-.191c0,0,1.11-2.408,2.776-1.669,0,0,.371-3.894,3.71-4.274V19.772a15.655,15.655,0,0,1-3.71,3.712Z",
    transform: "translate(-25.141 -1.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M28.382,68.385a1.834,1.834,0,1,0-1.843-1.838,1.835,1.835,0,0,0,1.843,1.838",
    transform: "translate(-19.765 -48.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M29.851,85.089a1.835,1.835,0,1,0-1.83-1.838,1.839,1.839,0,0,0,1.83,1.838",
    transform: "translate(-20.868 -60.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M10,102.156H35.346V82.137c-1.851.185-4.084,4.259-4.084,4.259a2.39,2.39,0,0,0-2.4,1.853c.737-.925,2.4-.185,2.4-.185V98.45H17.174V79.168l-3.522,3.71c-1.482-.185-2.591,1.659-2.591,1.659.744-.735,2.4,0,2.4,0v2.046C2.536,91.031,2.536,96.593,2.536,96.593v5.563h8.011l.231-3.706H6.425l.184-2.784a13.637,13.637,0,0,1,6.673-4.821V98.45H9.949Z",
    transform: "translate(-1.889 -58.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 3.899,
    height: 13.544,
    transform: "translate(11.393 44.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M85.048,175.149a1.837,1.837,0,1,0-1.833-1.844,1.846,1.846,0,0,0,1.833,1.844",
    transform: "translate(-61.974 -127.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M103.2,175.149a1.837,1.837,0,1,0-1.832-1.844,1.836,1.836,0,0,0,1.832,1.844",
    transform: "translate(-75.492 -127.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M143.136,31.143V29.1s1.67-.74,2.418.185a2.407,2.407,0,0,0-2.418-1.853s-2.22-4.074-4.073-4.259v11.86h26.694V29.664s1.3-1.3,1.852-1.106V39.672H139.248V51.533c1.847-.179,4.078-4.256,4.078-4.256a2.4,2.4,0,0,0,2.41-1.857c-.74.928-2.41.179-2.41.179V43.566h37.45v1.487s-.553.925-1.855.187c0,0-.37,2.214,3.521,2.038a5.686,5.686,0,0,0,3.525,2.778c2.6.738,3.892,1.112,3.892,2.225V42.827h11.117a13.777,13.777,0,0,1,0-3.156c.2-2.038-.735-5.376-2.963-6.863a1.034,1.034,0,0,1,1.67-.179s-1.67-2.225-3.521-1.115a10.073,10.073,0,0,0-5,.744s5.185,1.3,5.743,5.193V39.49h-7.041V6.116s2.035-.929,2.779,0a2.4,2.4,0,0,0-2.407-1.851S188.007.187,186.148,0V46.159a3.631,3.631,0,0,1-1.667-3.148V39.672H171.133V22.989a6.965,6.965,0,0,1-2.783,1.482c-1.854.553-4.072,1.666-4.627,2.778,0,0-2.971-.738-3.528,1.481,0,0,1.67-.173,1.67.374v2.038Z",
    transform: "translate(-103.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M352.31,176.592a1.837,1.837,0,1,0-1.837-1.835,1.837,1.837,0,0,0,1.837,1.835",
    transform: "translate(-261.013 -128.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M21.7,222.449h7.319v8.9s-.556-1.114,3.341-1.852,4.263-3.522,4.263-3.522c4.631,1.112,3.149-2.781,3.149-2.781-.368,1.86-1.852.556-1.852.556V222.27H79.627v1.3c-.189,2.036-1.672-.184-1.672-.184-.183,4.074,3.153,2.778,3.153,2.778.559,1.672,3.337,3.527,5.006,3.888a5.392,5.392,0,0,1,2.775,1.864V222.27h3.254l.317-3.71h-3.75v-7.968s5.379,2.222,6.117,4.074c0,0,1.294.926,1.294,3.894H92.187l-.61,3.71h8.251v-4.826c0-5.369-6.3-8.709-8.713-9.636a39.175,39.175,0,0,1-6.3-3.707v20.954c-1.3-.188-1.673-1.86-1.673-1.86V218.56H76.292v-15.2s.182.739-1.3,1.478a4.006,4.006,0,0,0-1.857,2.593,3.4,3.4,0,0,0-2.411,2.228c.186-1.112,2.227-.186,2.227-.186v8.9H69.985V203.544s.186.741-1.3,1.479a4.03,4.03,0,0,0-1.852,2.6,3.369,3.369,0,0,0-2.407,2.228c.182-1.113,2.225-.188,2.225-.188v8.713H63.863V203.544s.19.741-1.288,1.479a4.04,4.04,0,0,0-1.861,2.6,3.387,3.387,0,0,0-2.408,2.228c.186-1.113,2.228-.188,2.228-.188v8.713H52V203.544c-1.113,1.479-2.412,1.675-4.261,2.222a5.169,5.169,0,0,0-2.779,2.413c-3.155.744-3.711,3.9-4.083,5.556a3.475,3.475,0,0,1-1.294,2.228h6.88l.3-3.022h-1.74a1.714,1.714,0,0,1,1.729-1.794c.123-.929,1.551-1.424,1.551-1.424v3.217h-2.25l-.205,3.022h2.637v2.41H34.207a41.792,41.792,0,0,1,0,5.009,2,2,0,0,1-1.67,1.852V209.848h-20.2a4.014,4.014,0,0,0-2.784,1.3l-4.266,7.6H3.247l.55,3.7H21.7l.091-3.889H9.734l1.917-3.518a3.092,3.092,0,0,1,2.717-1.112H28.827v4.63H21.591Z",
    transform: "translate(-2.418 -151.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M162.1,197.674a1.837,1.837,0,1,0,0-3.675,1.837,1.837,0,0,0,0,3.675",
    transform: "translate(-119.355 -144.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M180.26,197.674a1.837,1.837,0,1,0-1.833-1.84,1.849,1.849,0,0,0,1.833,1.84",
    transform: "translate(-132.882 -144.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M0,346.338,1.379,339.3l2.246,5.087L5.952,339.3l1.231,7.038h-1l-.642-3.955-1.931,4.257-1.88-4.26-.7,3.958Z",
    transform: "translate(0 -252.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M0,346.338,1.379,339.3l2.246,5.087L5.952,339.3l1.231,7.038h-1l-.642-3.955-1.931,4.257-1.88-4.26-.7,3.958Z",
    transform: "translate(0 -252.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M34.587,341.207v3.943a2.155,2.155,0,0,0,.278,1.236,1.471,1.471,0,0,0,2.316,0,2.108,2.108,0,0,0,.278-1.236v-3.943h.985v4.213a2.423,2.423,0,1,1-4.845,0v-4.213Z",
    transform: "translate(-25.023 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M34.587,341.207v3.943a2.155,2.155,0,0,0,.278,1.236,1.471,1.471,0,0,0,2.316,0,2.108,2.108,0,0,0,.278-1.236v-3.943h.985v4.213a2.423,2.423,0,1,1-4.845,0v-4.213Z",
    transform: "translate(-25.023 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M61.484,341.819l-.8.478a1.378,1.378,0,0,0-.424-.507,1.021,1.021,0,0,0-.548-.137,1.007,1.007,0,0,0-.678.234.7.7,0,0,0-.277.575c0,.323.236.576.715.772l.647.273a2.8,2.8,0,0,1,1.17.787,1.8,1.8,0,0,1,.364,1.142,2,2,0,0,1-.6,1.487,2.03,2.03,0,0,1-1.5.592,2.005,2.005,0,0,1-1.4-.5,2.338,2.338,0,0,1-.684-1.425l1-.217a1.568,1.568,0,0,0,.239.787,1.01,1.01,0,0,0,.888.433,1.027,1.027,0,0,0,.77-.313,1.07,1.07,0,0,0,.3-.781,1.637,1.637,0,0,0-.045-.348,1.011,1.011,0,0,0-.169-.3,1.391,1.391,0,0,0-.287-.249,2.8,2.8,0,0,0-.429-.216l-.628-.27c-.888-.378-1.345-.928-1.345-1.656a1.589,1.589,0,0,1,.562-1.236,2.039,2.039,0,0,1,1.411-.5,1.961,1.961,0,0,1,1.764,1.094",
    transform: "translate(-42.788 -253.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M61.484,341.819l-.8.478a1.378,1.378,0,0,0-.424-.507,1.021,1.021,0,0,0-.548-.137,1.007,1.007,0,0,0-.678.234.7.7,0,0,0-.277.575c0,.323.236.576.715.772l.647.273a2.8,2.8,0,0,1,1.17.787,1.8,1.8,0,0,1,.364,1.142,2,2,0,0,1-.6,1.487,2.03,2.03,0,0,1-1.5.592,2.005,2.005,0,0,1-1.4-.5,2.338,2.338,0,0,1-.684-1.425l1-.217a1.568,1.568,0,0,0,.239.787,1.01,1.01,0,0,0,.888.433,1.027,1.027,0,0,0,.77-.313,1.07,1.07,0,0,0,.3-.781,1.637,1.637,0,0,0-.045-.348,1.011,1.011,0,0,0-.169-.3,1.391,1.391,0,0,0-.287-.249,2.8,2.8,0,0,0-.429-.216l-.628-.27c-.888-.378-1.345-.928-1.345-1.656a1.589,1.589,0,0,1,.562-1.236,2.039,2.039,0,0,1,1.411-.5,1.961,1.961,0,0,1,1.764,1.094",
    transform: "translate(-42.788 -253.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M82.477,341.2v1.174a2.754,2.754,0,0,0-1.773-.721,2.255,2.255,0,0,0-1.7.726,2.456,2.456,0,0,0-.7,1.766,2.408,2.408,0,0,0,.7,1.74,2.289,2.289,0,0,0,1.7.706,2.051,2.051,0,0,0,.888-.171,2.475,2.475,0,0,0,.421-.231,4.986,4.986,0,0,0,.461-.345v1.194a3.592,3.592,0,0,1-1.787.478,3.3,3.3,0,0,1-2.392-.975,3.241,3.241,0,0,1-.984-2.382,3.324,3.324,0,0,1,.828-2.231,3.257,3.257,0,0,1,2.631-1.2,3.4,3.4,0,0,1,1.7.475",
    transform: "translate(-57.579 -253.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M82.477,341.2v1.174a2.754,2.754,0,0,0-1.773-.721,2.255,2.255,0,0,0-1.7.726,2.456,2.456,0,0,0-.7,1.766,2.408,2.408,0,0,0,.7,1.74,2.289,2.289,0,0,0,1.7.706,2.051,2.051,0,0,0,.888-.171,2.475,2.475,0,0,0,.421-.231,4.986,4.986,0,0,0,.461-.345v1.194a3.592,3.592,0,0,1-1.787.478,3.3,3.3,0,0,1-2.392-.975,3.241,3.241,0,0,1-.984-2.382,3.324,3.324,0,0,1,.828-2.231,3.257,3.257,0,0,1,2.631-1.2,3.4,3.4,0,0,1,1.7.475",
    transform: "translate(-57.579 -253.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M104.289,344.037l-.973-2.225-1.017,2.225Zm.4.937h-2.8l-.729,1.59H100.1l3.239-6.961,3.124,6.961h-1.088Z",
    transform: "translate(-74.548 -252.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M104.289,344.037l-.973-2.225-1.017,2.225Zm.4.937h-2.8l-.729,1.59H100.1l3.239-6.961,3.124,6.961h-1.088Z",
    transform: "translate(-74.548 -252.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M126.6,342.141v5.618h-.991v-5.618H124.1v-.934h3.99v.934Z",
    transform: "translate(-92.424 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M126.6,342.141v5.618h-.991v-5.618H124.1v-.934h3.99v.934Z",
    transform: "translate(-92.424 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M152.805,346.338l1.38-7.038,2.246,5.087,2.329-5.087,1.235,7.038h-1.012l-.633-3.955-1.94,4.257-1.878-4.26-.709,3.958Z",
    transform: "translate(-113.801 -252.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M152.805,346.338l1.38-7.038,2.246,5.087,2.329-5.087,1.235,7.038h-1.012l-.633-3.955-1.94,4.257-1.878-4.26-.709,3.958Z",
    transform: "translate(-113.801 -252.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M187.407,341.207v3.943a2.195,2.195,0,0,0,.275,1.236,1.469,1.469,0,0,0,2.314,0,2.11,2.11,0,0,0,.278-1.236v-3.943h.988v4.213a2.367,2.367,0,0,1-2.424,2.453,2.366,2.366,0,0,1-2.42-2.453v-4.213Z",
    transform: "translate(-138.834 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M187.407,341.207v3.943a2.195,2.195,0,0,0,.275,1.236,1.469,1.469,0,0,0,2.314,0,2.11,2.11,0,0,0,.278-1.236v-3.943h.988v4.213a2.367,2.367,0,0,1-2.424,2.453,2.366,2.366,0,0,1-2.42-2.453v-4.213Z",
    transform: "translate(-138.834 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M211.563,346.46v-7l4.767,5v-4.552h1v6.949l-4.777-4.983v4.585Z",
    transform: "translate(-157.56 -252.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M211.563,346.46v-7l4.767,5v-4.552h1v6.949l-4.777-4.983v4.585Z",
    transform: "translate(-157.56 -252.813)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 0.992,
    height: 6.552,
    transform: "translate(61.328 87.095)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 0.992,
    height: 6.552,
    transform: "translate(61.328 87.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M254.2,341.2v1.174a2.742,2.742,0,0,0-1.77-.721,2.264,2.264,0,0,0-1.7.726,2.443,2.443,0,0,0-.695,1.766,2.394,2.394,0,0,0,.695,1.74,2.315,2.315,0,0,0,1.7.706,2.015,2.015,0,0,0,.886-.171,1.938,1.938,0,0,0,.416-.231,5.376,5.376,0,0,0,.465-.345v1.194a3.575,3.575,0,0,1-1.781.478,3.28,3.28,0,0,1-2.393-.975,3.241,3.241,0,0,1-.988-2.382,3.385,3.385,0,0,1,.826-2.231,3.268,3.268,0,0,1,2.631-1.2,3.407,3.407,0,0,1,1.7.475",
    transform: "translate(-185.469 -253.753)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M254.2,341.2v1.174a2.742,2.742,0,0,0-1.77-.721,2.264,2.264,0,0,0-1.7.726,2.443,2.443,0,0,0-.695,1.766,2.394,2.394,0,0,0,.695,1.74,2.315,2.315,0,0,0,1.7.706,2.015,2.015,0,0,0,.886-.171,1.938,1.938,0,0,0,.416-.231,5.376,5.376,0,0,0,.465-.345v1.194a3.575,3.575,0,0,1-1.781.478,3.28,3.28,0,0,1-2.393-.975,3.241,3.241,0,0,1-.988-2.382,3.385,3.385,0,0,1,.826-2.231,3.268,3.268,0,0,1,2.631-1.2,3.407,3.407,0,0,1,1.7.475",
    transform: "translate(-185.469 -253.753)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 0.988,
    height: 6.552,
    transform: "translate(69.978 87.095)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 0.988,
    height: 6.552,
    transform: "translate(69.978 87.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M285.153,344.185h.37c.9,0,1.359-.358,1.359-1.048s-.468-1.018-1.4-1.018h-.33Zm0,.91v2.664h-1v-6.552h1.122a4.679,4.679,0,0,1,1.245.12,1.658,1.658,0,0,1,.75.43,1.867,1.867,0,0,1,.565,1.387,1.823,1.823,0,0,1-.6,1.43,2.387,2.387,0,0,1-1.625.521Z",
    transform: "translate(-211.625 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M285.153,344.185h.37c.9,0,1.359-.358,1.359-1.048s-.468-1.018-1.4-1.018h-.33Zm0,.91v2.664h-1v-6.552h1.122a4.679,4.679,0,0,1,1.245.12,1.658,1.658,0,0,1,.75.43,1.867,1.867,0,0,1,.565,1.387,1.823,1.823,0,0,1-.6,1.43,2.387,2.387,0,0,1-1.625.521Z",
    transform: "translate(-211.625 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M301.919,344.037l-.966-2.225-1.025,2.225Zm.407.937h-2.811l-.727,1.59h-1.062l3.245-6.961,3.122,6.961h-1.079Z",
    transform: "translate(-221.729 -252.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M301.919,344.037l-.966-2.225-1.025,2.225Zm.407.937h-2.811l-.727,1.59h-1.062l3.245-6.961,3.122,6.961h-1.079Z",
    transform: "translate(-221.729 -252.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M326.852,341.207v5.624h1.929v.928h-2.918v-6.552Z",
    transform: "translate(-242.684 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M326.852,341.207v5.624h1.929v.928h-2.918v-6.552Z",
    transform: "translate(-242.684 -254.112)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 0.986,
    height: 6.552,
    transform: "translate(87.032 87.095)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 0.986,
    height: 6.552,
    transform: "translate(87.032 87.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M350.8,342.141v5.618h-1v-5.618h-1.5v-.934h4v.934Z",
    transform: "translate(-259.394 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M350.8,342.141v5.618h-1v-5.618h-1.5v-.934h4v.934Z",
    transform: "translate(-259.394 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M368,344.93l-2.139-3.723H367l1.493,2.613L370,341.207h1.137l-2.146,3.723v2.829H368Z",
    transform: "translate(-272.476 -254.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M368,344.93l-2.139-3.723H367l1.493,2.613L370,341.207h1.137l-2.146,3.723v2.829H368Z",
    transform: "translate(-272.476 -254.112)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Logo.8d8468d0116578acca71063a71db592e.svg";